import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'

export const payment = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const refund = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/refund'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const createPaypalOrder = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/create-paypal-order'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const paypalOrderApproval = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/paypal-order-approval'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const cardCredit = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/card-credit'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const cardIntegrated = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/card-integrated'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const cancelCardOrder = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/cancel-card-order'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** 결제 견적 — 장바구니·결제 화면 금액의 출처 (judahsWeb/CHECKOUT_PLAN.md §2) */
export const quote = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/quote'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** 결제 화면 열기 — 견적 + 가격 잠금(USD 15분 · KRW 30분) (CHECKOUT_PLAN §13) */
export const checkoutOpen = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/checkout-open'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** 상시판매 카트 홀드 동기화 (CHECKOUT_PLAN §11) */
export const cartHold = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/cart-hold'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** 백오피스 환불 — PayPal 캡처 환불. `POST /payment/paypal-refund` { captureId } (인증 필요, 환불 잠금은 서버가 본다) */
export const paypalRefund = async ({
	body = { captureId: '' } as { captureId: string },
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/paypal-refund'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** 백오피스 환불 — PayVerse 카드 취소. `POST /payment/card-cancel` { tid, currency, amount } (관리자 전용) */
export const cardCancel = async ({
	body = { tid: '', currency: 'USD', amount: 0 } as {
		tid: string
		currency: 'USD' | 'KRW'
		amount: number
	},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/card-cancel'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** PayVerse 통합결제창(브라우저) 콜백 결과를 서버 원장에 남긴다 — 실패 이유가 서버에도 남도록 */
export const cardIntegratedResult = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/card-integrated-result'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** 주문 확정 여부 — KRW 는 웹훅이 확정하므로 성공 화면 전에 이 값을 폴링한다 */
export const orderStatus = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/payment/order-status'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const paymentApi = {
	payment,
	quote,
	checkoutOpen,
	cartHold,
	refund,
	paypalRefund,
	cardCancel,
	createPaypalOrder,
	paypalOrderApproval,
	cardCredit,
	cardIntegrated,
	cardIntegratedResult,
	orderStatus,
	cancelCardOrder,
}

export default paymentApi
